import type { ChakraProps } from "@chakra-ui/react";

export const customClassNames: Record<string, ChakraProps["sx"]> = {
  ".white": {
    color: "white",
  },
  ".brandBlueFont": {
    color: "primary.500",
  },
  ".brandingDark": {
    color: "greyscale.500",
  },
  ".greyscale700": {
    color: "greyscale.700",
  },
  ".greyscale600": {
    color: "greyscale.600",
  },
  ".medium": {
    fontSize: "md",
    lineHeight: "base",
  },
  ".font-size-small": {
    fontSize: "sm",
  },
  ".font-size-medium": {
    fontSize: "md",
  },
  ".font-size-large": {
    fontSize: "lg",
  },
  ".font-size-2xl": {
    fontSize: "2xl",
  },
  ".underline": {
    textDecoration: "underline",
  },
  ".display-inline": {
    display: "inline",
  },
  ".font-weight-normal": {
    fontWeight: "normal",
  },
  ".font-weight-medium": {
    fontWeight: "medium",
  },
  ".font-weight-bold": {
    fontWeight: "bold",
  },
  ".margin-bottom-0": {
    mb: 0,
  },
  ".margin-bottom-3": {
    mb: 3,
  },
  ".margin-bottom-5": {
    mb: 5,
  },
  ".margin-bottom-6": {
    mb: 6,
  },
  ".margin-bottom-8": {
    mb: 8,
  },
  ".margin-top-6": {
    mt: 6,
  },
  ".margin-top-7": {
    mt: 7,
  },
  ".display-block": {
    display: "block",
  },
  ".primary700": {
    color: "primary.700",
  },
  ".subheading": {
    color: "primary.500",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    fontSize: "xs",
    fontWeight: "bold",
  },
  ".display-inline-block": {
    display: "inline-block",
  },
  ".font-size-60": {
    fontSize: "60px",
  },
  ".vertical-align-text-top": {
    verticalAlign: "top",
  },
  ".color-greyscale-600": {
    color: "greyscale.600",
  },
  ".color-success-600": {
    color: "success.600",
  },
  ".line-height-short": {
    lineHeight: "base",
  },
};
